import { NavLink } from 'react-router';
import { Brand } from './Brand.jsx';
import { Icon } from '../ui/Icon.jsx';
import { navLinks } from '../../data/site.js';
import styles from './Header.module.css';

export function Header({ headerRef, onOpenMenu, menuOpen, menuId, toggleRef }) {
  return (
    <header className={styles.header} ref={headerRef}>
      <div className={styles.inner}>
        <Brand />

        <nav className={styles.nav} aria-label="Primary">
          {navLinks.map(({ to, label }) => (
            /* NavLink sets aria-current="page" on the active route by
               itself, and the stylesheet keys off that attribute rather
               than a separate active class — one signal, so the visual
               state and the accessible one cannot drift apart. */
            <NavLink key={to} to={to} end={to === '/'}>
              {label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          ref={toggleRef}
          className={styles.toggle}
          aria-expanded={menuOpen}
          aria-controls={menuId}
          aria-label="Open menu"
          onClick={onOpenMenu}
        >
          <Icon name="menu" strokeWidth={1.75} />
        </button>
      </div>
    </header>
  );
}
